import React, { useState } from "react";
import dayjs from "utils/dayjs";
import "./VideoMessageContent.scss";
import { ReactComponent as DownloadIcon } from "images/download_for_offline-24px.svg";
import { MdVideocam } from "react-icons/md";
import ReactPlayer from "react-player";
import useMediaApi from "hooks/useMediaApi";
import LazyLoad from "react-lazy-load";
import { Spinner } from "react-bootstrap";

export default function VideoMessageContent(props) {
  const { message, highlighted, isTransferred } = props;
  const highlightedClass = highlighted ? "highlighted" : "";
  const transferredClass = isTransferred & !highlighted ? "transferred" : "";
  const renderMessageTime = (timestamp) => {
    return dayjs(timestamp).format("hh:mm A");
  };

  const [isContentVisible, setContentVisible] = useState(false);
  const { mediaUrl, isLoading } = useMediaApi(
    message.fileUrl,
    message.channel,
    isContentVisible
  );

  return (
    <div
      className={`video-msg-ctr ${transferredClass} ${highlightedClass}`}
      data-testid="video-message-content"
    >
      <LazyLoad
        placeholder="loading video"
        offset={100}
        height={180}
        width={300}
        onContentVisible={() => setContentVisible(true)}
      >
        {isLoading ? (
          <Spinner animation="border" />
        ) : (
          <div className="video-container">
            <ReactPlayer
              height="100%"
              width="100%"
              className="video-div"
              url={mediaUrl}
            />
            <div className="video-icon-wrapper">
              <MdVideocam size="1.5em" className="video-icon" />
            </div>
            <div className="overlay">
              <div className="download-image">
                <a href={mediaUrl} download>
                  <DownloadIcon />
                  <div className="download-txt">Download</div>
                </a>
              </div>
            </div>
          </div>
        )}
      </LazyLoad>
      <div className="message-time-video">
        {renderMessageTime(message.messageTime)}
      </div>
      <div className="caption-content">{message.message}</div>
    </div>
  );
}
